import axios from 'axios';

// Types
export const FETCH_USER = 'FETCH_USER';
export const STAR_LIST = 'STAR_LIST';
export const UNSTAR_LIST = 'UNSTAR_LIST';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const TOGGLE_VIEW = 'TOGGLE_VIEW';

let baseUrl = '';

if (process.env.NODE_ENV === 'production') {
	baseUrl = 'https://nivea-marlies-checklist-api.herokuapp.com';
} else {
	baseUrl = 'http://localhost:5000';
}

export const fetchUser = userId => {
	// id needs to be added
	const url = `${baseUrl}/user?userId=${userId}`;
	const request = axios.get(url);

	return {
		type: FETCH_USER,
		meta: { userId: userId },
		payload: request // we're returning a Promise here
	};
};

export const starList = (userId, listId) => {
	console.log(userId + '---' + listId);
	// star in database
	const url = `${baseUrl}/user/addStar`;
	const request = axios.post(url, {
		userId: userId,
		listId: listId
	});

	return {
		type: STAR_LIST,
		meta: { id: listId },
		payload: request
	};
};

export const unstarList = (userId, listId) => {
	const url = `${baseUrl}/user/removeStar`;
	const request = axios.post(url, {
		userId: userId,
		listId: listId
	});

	return {
		type: UNSTAR_LIST,
		meta: { id: listId },
		payload: request
	};
};

export const addItem = (userId, listId, itemId) => {
	const url = `${baseUrl}/user/addItem`;
	const request = axios.post(url, {
		userId: userId,
		listId: listId,
		itemId: itemId
	});

	return {
		type: ADD_ITEM,
		meta: {
			listId: listId,
			itemId: itemId
		},
		payload: request
	};
};

export const removeItem = (userId, listId, itemId) => {
	const url = `${baseUrl}/user/deleteItem`;
	const request = axios.post(url, {
		userId: userId,
		listId: listId,
		itemId: itemId
	});

	return {
		type: REMOVE_ITEM,
		meta: {
			listId: listId,
			itemId: itemId
		},
		payload: request
	};
};

export const toggleView = newView => {
	return {
		type: TOGGLE_VIEW,
		newView: newView
	};
};



// WEBPACK FOOTER //
// ./src/actions/actions_user.js